/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import Card from "../../shared-ui/card";
import Slider from "react-slick";

// Interface for FoodComponent State
interface FoodComponentState {}

// Interface for FoodComponent Props
interface FoodComponentProps {
  colClassName: string;
  history?: any;
  cardSettings?: any;
  handleSeeMore?: (index: number, heading: string) => void;
  foodsData?: any;
  foodSubType?: any;
  handleSeeMoreOnKeyPress?: (index: number, heading: string, e?: any) => void;
}

/**
 * FoodComponent component.
 *
 * @namespace FoodComponent
 */
class FoodComponent extends React.Component<
  FoodComponentProps,
  FoodComponentState
> {
  constructor(props: any) {
    super(props);
    // this.state = {
    // };
  }

  render() {
    const { colClassName, cardSettings, foodsData, foodSubType } = this.props;

    const splitedStr = this.props.history.location.pathname.split("/");
    const pathName = splitedStr && splitedStr.slice(1).pop();
    return (
      <div className="food-card-wrapper">
        <div className="bootstrap-wrapper">
          {/* For Mobile View Start */}
          {pathName === "results" ? (
            <div className="inner-wrapper visible-xs col-md-12 clearfix">
              <Slider {...cardSettings}>
                {foodsData && foodsData.length > 0
                  ? //&&
                    // needStateImages &&
                    // needStateImages.length > 0
                    foodsData.map((item: any, index: number) => (
                      <div
                        key={index}
                        tabIndex={0}
                        className={`${colClassName} cards-wrapper pull-left`}
                      >
                        <Card
                          {...this.props}
                          handleSeeMore={(heading: string) => {
                            if (this.props.handleSeeMore) {
                              this.props.handleSeeMore(index, heading);
                            }
                          }}
                          handleSeeMoreOnKeyPress={(
                            heading: string,
                            e: any
                          ) => {
                            if (this.props.handleSeeMoreOnKeyPress) {
                              this.props.handleSeeMoreOnKeyPress(
                                index,
                                heading,
                                e
                              );
                            }
                          }}
                          foodSubType={foodSubType}
                          needStateImages={item?.overLapImages}
                          // needStateImages={needStateImages}
                          title={item?.data?.food_title}
                          description={item?.data?.what_content}
                          imageUrl={item?.data?.what_image?.url}
                          type="foods"
                        />
                      </div>
                    ))
                  : null}
              </Slider>
            </div>
          ) : null}
          {/* For Mobile View Ends */}

          {/* For Desktop View Start */}
          <div
            className={`inner-wrapper ${
              pathName === "results" ? "visible-lg " : ""
            }`}
          >
            <div className="cards-area row col-md-12 clearfix">
              {foodsData && foodsData.length > 0
                ? //&&
                  // needStateImages &&
                  // needStateImages.length > 0
                  foodsData.map((item: any, index: number) => (
                    <>
                      <div
                        className={`${colClassName} cards-wrapper pull-left`}
                        key={index}
                      >
                        <Card
                          {...this.props}
                          handleSeeMore={(heading: string) => {
                            if (this.props.handleSeeMore) {
                              this.props.handleSeeMore(index, heading);
                            }
                          }}
                          handleSeeMoreOnKeyPress={(
                            heading: string,
                            e: any
                          ) => {
                            if (this.props.handleSeeMoreOnKeyPress) {
                              this.props.handleSeeMoreOnKeyPress(
                                index,
                                heading,
                                e
                              );
                            }
                          }}
                          foodSubType={foodSubType}
                          needStateImages={item?.overLapImages}
                          title={item?.data?.food_title}
                          description={item?.data?.what_content}
                          imageUrl={item?.data?.what_image?.url}
                          type="foods"
                        />
                      </div>
                    </>
                  ))
                : null}
            </div>
            {/* Card Container Start */}
            {/* <div className={`${colClassName} cards-wrapper pull-left`}>
              <Card handleSeeMore={this.props.handleSeeMore} />
            </div> */}
            {/* Card Container Ends */}

            {/* Card Container Start */}
            {/* <div className={`${colClassName} cards-wrapper pull-left`}>
              <Card />
            </div> */}
            {/* Card Container Ends */}

            {/* Card Container Start */}
            {/* <div className={`${colClassName} cards-wrapper pull-left`}>
              <Card />
            </div> */}
            {/* Card Container Ends */}

            {/* Card Container Start */}
            {/* <div className={`${colClassName} cards-wrapper pull-left`}>
              <Card />
            </div> */}
            {/* Card Container Ends */}
          </div>
          {/* For Desktop View Ends */}
        </div>
      </div>
    );
  }
}

export default FoodComponent;
